export default "__VITE_ASSET__D_gGu0HK__"